// This script should be added *after* your existing cart logic script
// It adds display update functionality while preserving business rule messages

(function() {
  console.log('Cart display update enhancement loading');
  
  // Preserve original functions if they exist
  const originalGetNextIncrement = window.getNextIncrement;
  const originalGetPreviousIncrement = window.getPreviousIncrement;
  const originalAdjustQuantity = window.adjustQuantity;
  
  // Make sure we don't overwrite existing functions
 window.getNextIncrement = function(quantity) {
  console.log('Enhanced getNextIncrement called with:', quantity);
  // Always return 1 instead of calling the original function
  return 1;
};

window.getPreviousIncrement = function(quantity) {
  console.log('Enhanced getPreviousIncrement called with:', quantity);
  // Always return 1 instead of calling the original function
  return 1;
};
  
  window.adjustQuantity = function(value) {
    console.log('Enhanced adjustQuantity called with:', value);
    // Call the original function if it exists
    if (typeof originalAdjustQuantity === 'function') {
      return originalAdjustQuantity(value);
    }
    // Default implementation if original doesn't exist
    const quantity = parseInt(value) || 0;
    return quantity;
  };
  
  // Function to get current cart data
  async function fetchCartContents() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
  
  // Function to update cart displays without modifying behavior
  function updateCartDisplay(cartData) {
    if (!cartData) return;
    
    console.log('Updating cart display with:', cartData.item_count + ' items');
    
    // Update cart count elements
    const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, .site-header__cart-count span, .header__cart-count');
    cartCountElements.forEach(element => {
      if (element) {
        element.textContent = cartData.item_count;
        // Make parent visible if it was hidden
        const parent = element.parentElement;
        if (parent && parent.style.display === 'none') {
          parent.style.display = '';
        }
      }
    });
    
    // Update cart total if we're on the cart page
    if (window.location.pathname.includes('/cart')) {
      // Update the quantity inputs to match what's in the cart
      if (cartData.items && Array.isArray(cartData.items)) {
        cartData.items.forEach(item => {
          if (!item || !item.variant_id) return;
          
          // Try multiple selector patterns to find the item row
          const selectors = [
            `[data-variant-id="${item.variant_id}"]`, 
            `[data-line-id="${item.key}"]`, 
            `[data-key="${item.key}"]`,
            `[data-cart-item-key="${item.key}"]`,
            `#CartItem-${item.key}`
          ];
          
          // Use querySelectorAll with multiple selectors joined by commas
          const itemRows = document.querySelectorAll(selectors.join(', '));
          
          itemRows.forEach(row => {
            if (!row) return;
            const quantityInput = row.querySelector('input[name="quantity"], input[name="updates[]"]');
            if (quantityInput) {
              quantityInput.value = item.quantity;
            }
          });
        });
      }
      
      // Update subtotal prices
      try {
        const subtotalElements = document.querySelectorAll('.cart-subtotal__price, .cart__total-price, .cart__final-price');
        subtotalElements.forEach(element => {
          if (!element) return;
          // Use Shopify's formatMoney if available, otherwise basic formatting
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            element.innerHTML = Shopify.formatMoney(cartData.total_price);
          } else {
            // Basic money formatting as fallback
            const formattedPrice = '$' + (cartData.total_price / 100).toFixed(2);
            element.innerHTML = formattedPrice;
          }
        });
      } catch (e) {
        console.error('Error updating prices:', e);
      }
    }
    
    // Update business rule messages
    updateBusinessRuleMessages(cartData);
    
    // Trigger standard Shopify events to ensure theme-specific updates occur
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
  }
  
  // Helper function to identify product weight type
  function identifyProductWeight(item) {
    // Try multiple methods to identify the product weight
    
    // Method 1: Check the product_type field (preferred method)
    if (item.product_type) {
      if (item.product_type.includes('20g') || item.product_type.toLowerCase().includes('20 g') || 
          item.product_type === '20g Drink' || item.product_type === 'Drink 20g') return '20g';
      // 30g PRODUCT TYPE CHECK
      if (item.product_type.includes('30g') || item.product_type.toLowerCase().includes('30 g') || 
          item.product_type === '30g Drink' || item.product_type === 'Drink 30g') return '30g';
      // 32g PRODUCT TYPE CHECK
      if (item.product_type.includes('32g') || item.product_type.toLowerCase().includes('32 g') || 
          item.product_type === '32g Drink' || item.product_type === 'Drink 32g') return '32g';
      if (item.product_type.includes('42g') || item.product_type.toLowerCase().includes('42 g') || 
          item.product_type === '42g Drink' || item.product_type === 'Drink 42g') return '42g';
    }
    
    // Method 2: Check for product tags (if available in the cart data)
    // Note: Standard cart.js response doesn't include tags, but some themes/apps add them
    if (item.tags && Array.isArray(item.tags)) {
      if (item.tags.some(tag => tag.includes('20g'))) return '20g';
      // 30g TAGS CHECK
      if (item.tags.some(tag => tag.includes('30g'))) return '30g';
      // 32g TAGS CHECK
      if (item.tags.some(tag => tag.includes('32g'))) return '32g';
      if (item.tags.some(tag => tag.includes('42g'))) return '42g';
    }
    
    // Method 3: Check the variant title
    if (item.variant_title) {
      if (item.variant_title.includes('20g') || item.variant_title.toLowerCase().includes('20 g')) return '20g';
      // 30g VARIANT TITLE CHECK
      if (item.variant_title.includes('30g') || item.variant_title.toLowerCase().includes('30 g')) return '30g';
      // 32g VARIANT TITLE CHECK
      if (item.variant_title.includes('32g') || item.variant_title.toLowerCase().includes('32 g')) return '32g';
      if (item.variant_title.includes('42g') || item.variant_title.toLowerCase().includes('42 g')) return '42g';
    }
    
    // Method 4: Check the SKU
    if (item.sku) {
      if (item.sku.includes('20G') || item.sku.includes('20g')) return '20g';
      // 30g SKU CHECK
      if (item.sku.includes('30G') || item.sku.includes('30g')) return '30g';
      // 32g SKU CHECK
      if (item.sku.includes('32G') || item.sku.includes('32g')) return '32g';
      if (item.sku.includes('42G') || item.sku.includes('42g')) return '42g';
    }
    
    // Method 5: Check the product title
    if (item.title) {
      if (item.title.includes('20g') || item.title.toLowerCase().includes('20 g')) return '20g';
      // 30g TITLE CHECK
      if (item.title.includes('30g') || item.title.toLowerCase().includes('30 g')) return '30g';
      // 32g TITLE CHECK
      if (item.title.includes('32g') || item.title.toLowerCase().includes('32 g')) return '32g';
      if (item.title.includes('42g') || item.title.toLowerCase().includes('42 g')) return '42g';
    }
    
    // If we can't determine from the above methods, we might need to fetch product metadata
    // This would require an additional API call per product, which could slow things down
    // Instead, let's use a naming convention approach based on what's available
    
    // Default to 20g if we can't determine (to maintain backward compatibility)
    console.log('Could not determine product weight for item:', item.title || 'Unknown item');
    return '20g';
  }
  
  // Function to update business rule messages
  function updateBusinessRuleMessages(cartData) {
    try {
      const totalItems = cartData.item_count;
      const checkoutButtons = document.querySelectorAll('[name="checkout"], .shopify-payment-button__button');
      
      // Count items of each weight type
      let items20g = 0;
      let items30g = 0; // Added 30g counter
      let items32g = 0;
      let items42g = 0;
      
      // Calculate counts by product type
      if (cartData.items && Array.isArray(cartData.items)) {
        cartData.items.forEach(item => {
          const weightType = identifyProductWeight(item);
          if (weightType === '20g') {
            items20g += item.quantity;
          } else if (weightType === '30g') {
            items30g += item.quantity; // Count 30g products
          } else if (weightType === '32g') {
            items32g += item.quantity;
          } else if (weightType === '42g') {
            items42g += item.quantity;
          }
        });
      }
      
      // Combined count for 20g, 30g, and 32g products (all follow the divisible by 4 rule)
      const itemsGroup1 = items20g + items30g + items32g;
      
      console.log(`Cart contains: ${items20g} 20g items, ${items30g} 30g items, ${items32g} 32g items, and ${items42g} 42g items (total: ${totalItems})`);
      
      // Determine if each product type meets its respective divisibility rule
      const isGroup1DivisibleBy4 = itemsGroup1 % 4 === 0 || itemsGroup1 === 0;
      const is42gDivisibleBy2 = items42g % 2 === 0 || items42g === 0;
      
      // Overall checkout validation
      const isValidForCheckout = isGroup1DivisibleBy4 && is42gDivisibleBy2;
      
      // Determine message thresholds (78 for 20g/30g/32g, 76 for 42g)
      const isGroup1PalletSize = itemsGroup1 >= 78; // Show message for 78 or more items
      const is42gPalletSize = items42g >= 76; // Show message for 76 or more items
      const showPalletMessage = isGroup1PalletSize || is42gPalletSize;
    
      // Update checkout buttons
      checkoutButtons.forEach(button => {
        if (!button) return;
        button.disabled = !isValidForCheckout;
        button.style.opacity = isValidForCheckout ? '1' : '0.5';
      });
    
      // Clear any existing error messages and containers
      const existingErrorMessages = document.querySelectorAll('.cart-limit-error, .cart-error-message, .cart-error-container');
      existingErrorMessages.forEach(msg => msg.remove());
      
      let hasErrors = false;
      const errorContainer = document.createElement('div');
      errorContainer.className = 'cart-error-container';
      errorContainer.style.marginTop = '15px';
      errorContainer.style.marginBottom = '15px';
      errorContainer.style.width = '100%'; // Ensure full width;
    
      // 100 item limit check and error has been removed
      
      // Create individual styled messages for each product type if needed
      
      // 20g, 30g, and 32g products message (combined)
      if (itemsGroup1 > 0 && !isGroup1DivisibleBy4) {
        const errorGroup1 = document.createElement('div');
        errorGroup1.className = 'cart-error-message';
        errorGroup1.style.backgroundColor = '#fff0f0';
        errorGroup1.style.padding = '12px 15px';
        errorGroup1.style.marginBottom = '10px';
        errorGroup1.style.borderLeft = '4px solid #ff3b30';
        errorGroup1.style.color = '#212529';
        errorGroup1.style.fontSize = '14px';
        errorGroup1.style.fontWeight = '500';
        errorGroup1.style.borderRadius = '4px';
        errorGroup1.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
        errorGroup1.textContent = `20g or 30g Protein Shakes: Add ${4 - (itemsGroup1 % 4)} more or remove ${itemsGroup1 % 4} to continue.`;
        
        errorContainer.appendChild(errorGroup1);
        hasErrors = true;
      }
      
      // 42g products message
      if (items42g > 0 && !is42gDivisibleBy2) {
        const error42g = document.createElement('div');
        error42g.className = 'cart-error-message';
        error42g.style.backgroundColor = '#fff0f0';
        error42g.style.padding = '12px 15px';
        error42g.style.marginBottom = '10px';
        error42g.style.borderLeft = '4px solid #ff3b30';
        error42g.style.color = '#212529';
        error42g.style.fontSize = '14px';
        error42g.style.fontWeight = '500';
        error42g.style.borderRadius = '4px';
        error42g.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
        error42g.textContent = `42g Ultra Protein Shakes: Add ${2 - (items42g % 2)} more or remove ${items42g % 2} to continue.`;
        
        errorContainer.appendChild(error42g);
        hasErrors = true;
      }
      
      // Add error container to the page if we have errors
      if (hasErrors) {
        // Try to insert before checkout button
        const firstCheckoutButton = checkoutButtons[0];
        if (firstCheckoutButton && firstCheckoutButton.parentNode) {
          firstCheckoutButton.parentNode.insertBefore(errorContainer, firstCheckoutButton);
        } else {
          // If no checkout button, try cart form
          const cartForm = document.querySelector('form[action="/cart"]');
          if (cartForm) {
            cartForm.appendChild(errorContainer);
          } else {
            // Last resort: try common cart containers
            const cartContainer = document.querySelector('.cart, .cart__items, #CartDrawer, .cart-drawer, .drawer__inner');
            if (cartContainer) {
              cartContainer.appendChild(errorContainer);
            }
          }
        }
      }
    
      // Remove any existing pallet messages
      const existingPalletMsgs = document.querySelectorAll('.pallet-order-message');
      existingPalletMsgs.forEach(msg => msg.remove());
      
      // Add pallet order message when appropriate
      if (showPalletMessage) {
        // Create a new pallet message
        const palletMsg = document.createElement('div');
        palletMsg.className = 'pallet-order-message';
        palletMsg.style.backgroundColor = '#ececec';
        palletMsg.style.padding = '15px';
        palletMsg.style.marginBottom = '20px';
        palletMsg.style.borderLeft = '4px solid #ff0000';
        palletMsg.style.color = '#212529';
        palletMsg.style.fontSize = '16px';
        palletMsg.style.borderRadius = '4px';
        palletMsg.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
        palletMsg.textContent = 'To receive discounted pricing for pallet orders, please email cody@slatemilk.com';
        
        // Try multiple positions to insert the message
        let inserted = false;
        
        // Try common cart containers
        const cartContainers = [
          document.querySelector('.cart'),
          document.querySelector('form[action="/cart"]'),
          document.querySelector('.cart__items'),
          document.querySelector('#CartDrawer'),
          document.querySelector('.cart-drawer'),
          document.querySelector('.drawer__inner')
        ].filter(Boolean); // Remove null values
        
        // Try to insert in the first valid container
        for (let i = 0; i < cartContainers.length; i++) {
          const container = cartContainers[i];
          if (container) {
            if (container.firstChild) {
              container.insertBefore(palletMsg, container.firstChild);
            } else {
              container.appendChild(palletMsg);
            }
            inserted = true;
            break;
          }
        }
        
        // If we couldn't find a container, try to add it before the checkout button
        if (!inserted) {
          const checkoutButton = document.querySelector('[name="checkout"]');
          if (checkoutButton && checkoutButton.parentNode) {
            checkoutButton.parentNode.insertBefore(palletMsg, checkoutButton);
          }
        }
      }
    } catch (e) {
      console.error('Error updating business rule messages:', e);
    }
  }
  
  // Function to show "Added to cart" notification
  function showAddedToCartNotification(cart) {
    try {
      // Check if a notification element already exists
      let notification = document.querySelector('.added-to-cart-notification');
      
      if (!notification) {
        // Create notification element
        notification = document.createElement('div');
        notification.className = 'added-to-cart-notification';
        notification.style.position = 'fixed';
        notification.style.top = '20px';
        notification.style.right = '20px';
        notification.style.backgroundColor = '#4CAF50';
        notification.style.color = 'white';
        notification.style.padding = '15px';
        notification.style.borderRadius = '4px';
        notification.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
        notification.style.zIndex = '9999';
        notification.style.opacity = '0';
        notification.style.transition = 'opacity 0.3s ease-in-out';
        
        document.body.appendChild(notification);
      }
      
      // Modified to show product-specific checkout messages
      let checkoutMsg = '';
      
      // Calculate product counts
      let items20g = 0;
      let items30g = 0; // Added 30g counter
      let items32g = 0;
      let items42g = 0;
      
      if (cart.items && Array.isArray(cart.items)) {
        cart.items.forEach(item => {
          const weightType = identifyProductWeight(item);
          if (weightType === '20g') {
            items20g += item.quantity;
          } else if (weightType === '30g') {
            items30g += item.quantity; // Count 30g products
          } else if (weightType === '32g') {
            items32g += item.quantity;
          } else if (weightType === '42g') {
            items42g += item.quantity;
          }
        });
      }
      
      // Combined count for 20g, 30g, and 32g items
      const itemsGroup1 = items20g + items30g + items32g;
      
      // Add checkout message for 20g/30g/32g products (combined)
      if (itemsGroup1 > 0 && itemsGroup1 % 4 !== 0) {
        checkoutMsg += `<div style="font-size: 0.9em; margin-top: 5px;">Add ${4 - (itemsGroup1 % 4)} more 20g, 30g, or 32g Protein Shakes</div>`;
      }
      
      // Add checkout message for 42g products
      if (items42g > 0 && items42g % 2 !== 0) {
        checkoutMsg += `<div style="font-size: 0.9em; margin-top: 5px;">Add ${2 - (items42g % 2)} more 42g Ultra Protein Shakes</div>`;
      }
      
      // Update notification content
      notification.innerHTML = `
        <div style="display: flex; align-items: center;">
          <div style="margin-right: 10px;">✓</div>
          <div>
            <strong>Added to cart</strong>
            <div>Total items: ${cart.item_count}</div>
            ${checkoutMsg}
          </div>
        </div>
      `;
      
      // Show notification
      setTimeout(() => {
        notification.style.opacity = '1';
      }, 10);
      
      // Hide after 3 seconds
      setTimeout(() => {
        notification.style.opacity = '0';
        
        // Remove from DOM after fade out
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
          }
        }, 300);
      }, 3000);
    } catch (e) {
      console.error('Error showing notification:', e);
    }
  }
  
  // Add cart fetch interception (without modifying behavior)
  function setupCartUpdateInterceptors() {
    // Intercept XMLHttpRequest for cart endpoints
    try {
      const originalXHROpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function() {
        this.addEventListener('load', function() {
          try {
            if (this.readyState === 4 && this.status === 200 &&
                this.responseURL && 
                (this.responseURL.includes('/cart/add.js') || 
                 this.responseURL.includes('/cart/change.js') || 
                 this.responseURL.includes('/cart/update.js'))) {
              
              // Wait a moment for any theme scripts to finish their work
              setTimeout(async () => {
                const updatedCart = await fetchCartContents();
                if (updatedCart) {
                  updateCartDisplay(updatedCart);
                }
              }, 200); // A bit longer delay to ensure theme scripts finish
            }
          } catch (e) {
            console.error('XHR intercept error:', e);
          }
        });
        
        return originalXHROpen.apply(this, arguments);
      };
    } catch (e) {
      console.error('Failed to intercept XHR:', e);
    }
    
    // Intercept fetch calls for cart endpoints
    try {
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        const fetchPromise = originalFetch.apply(this, arguments);
        
        try {
          if (typeof url === 'string' && 
              (url.includes('/cart/add.js') || 
               url.includes('/cart/change.js') || 
               url.includes('/cart/update.js'))) {
            
            fetchPromise.then(response => {
              if (response.ok) {
                // Wait a moment for any theme scripts to finish their work
                setTimeout(async () => {
                  const updatedCart = await fetchCartContents();
                  if (updatedCart) {
                    updateCartDisplay(updatedCart);
                  }
                }, 200); // A bit longer delay to ensure theme scripts finish
              }
              return response;
            }).catch(() => {}); // Catch here to prevent unhandled promise errors
          }
        } catch (e) {
          console.error('Fetch intercept error:', e);
        }
        
        return fetchPromise;
      };
    } catch (e) {
      console.error('Failed to intercept fetch:', e);
    }
  }
  
  // Also hook into any submit events on add-to-cart forms
  function setupFormInterception() {
    try {
      document.addEventListener('submit', function(e) {
        if (e.target && e.target.action && e.target.action.includes('/cart/add')) {
          // Don't interfere with the form submission
          // Just schedule an update check afterward
          setTimeout(async () => {
            const updatedCart = await fetchCartContents();
            if (updatedCart) {
              updateCartDisplay(updatedCart);
              
              // Show an "Added to cart" notification
              showAddedToCartNotification(updatedCart);
            }
          }, 500); // Longer delay for form submissions
        }
      }, false); // Use bubbling phase
      
      // Add direct listeners for quantity change buttons
      setupQuantityButtonListeners();
      
      // Add listeners for manual quantity input changes
      document.addEventListener('change', function(e) {
        if (e.target && 
            (e.target.name === 'quantity' || 
             e.target.name === 'updates[]' || 
             e.target.classList.contains('quantity-input'))) {
          // Schedule an update check after quantity input changes
          setTimeout(async () => {
            const updatedCart = await fetchCartContents();
            if (updatedCart) {
              updateCartDisplay(updatedCart);
            }
          }, 500);
        }
      }, false);
    } catch (e) {
      console.error('Form intercept error:', e);
    }
  }
  
  // Function to handle quantity button clicks
  function setupQuantityButtonListeners() {
    // Handle various button selectors that might be used across different themes
    const buttonSelectors = [
      '.quantity-down, .quantity-minus, .js-qty__adjust--minus, .cart__qty-decrease, [data-quantity-minus], .quantity__button[data-action="decrease"]',
      '.quantity-up, .quantity-plus, .js-qty__adjust--plus, .cart__qty-increase, [data-quantity-plus], .quantity__button[data-action="increase"]'
    ];
    
    // Setup a mutation observer to handle dynamically added elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Check if any added nodes are quantity controls or contain them
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1) { // Element node
              // If the node itself is a quantity control
              if (node.matches && (node.matches(buttonSelectors[0]) || node.matches(buttonSelectors[1]))) {
                attachQuantityButtonListener(node);
              }
              
              // If the node contains quantity controls
              const buttons = node.querySelectorAll(buttonSelectors.join(', '));
              buttons.forEach(button => attachQuantityButtonListener(button));
            }
          }
        }
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Attach listeners to existing buttons
    const existingButtons = document.querySelectorAll(buttonSelectors.join(', '));
    existingButtons.forEach(button => attachQuantityButtonListener(button));
    
    console.log(`Found and attached listeners to ${existingButtons.length} quantity buttons`);
  }
  
  // Helper function to attach click listener to a quantity button
  function attachQuantityButtonListener(button) {
    // Only attach if we haven't already
    if (button.hasAttribute('data-quantity-listener-attached')) {
      return;
    }
    
    button.setAttribute('data-quantity-listener-attached', 'true');
    
    button.addEventListener('click', function(e) {
      // Don't prevent default - let the theme's handler run
      // Just schedule our update check
      setTimeout(async () => {
        const updatedCart = await fetchCartContents();
        if (updatedCart) {
          updateCartDisplay(updatedCart);
        }
      }, 500);
    });
  }
  
  // Periodically check for cart changes (fallback method)
  function setupPeriodicCartCheck() {
    let lastCartItemCount = 0;
    
    const checkCartChanges = async () => {
      try {
        const cart = await fetchCartContents();
        if (cart && cart.item_count !== lastCartItemCount) {
          lastCartItemCount = cart.item_count;
          updateCartDisplay(cart);
        }
      } catch (e) {
        console.error('Periodic cart check error:', e);
      }
    };
    
    // Initial check
    checkCartChanges();
    
    // Setup periodic check every 2 seconds
    setInterval(checkCartChanges, 2000);
  }
  
  // Initialize our enhancements
  function initialize() {
    try {
      // First get the current cart state
      fetchCartContents().then(cartData => {
        if (cartData) {
          updateCartDisplay(cartData);
        }
      });
      
      // Setup the update interceptors
      setupCartUpdateInterceptors();
      setupFormInterception();
      setupPeriodicCartCheck();
      
      // Add direct listeners for quantity buttons
      console.log('Setting up quantity button listeners');
      setupQuantityButtonListeners();
      
      console.log('Cart display enhancement initialized');
    } catch (e) {
      console.error('Cart display enhancement init error:', e);
    }
  }
  
  // Run when the page is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 500); // Slight delay to ensure other scripts have loaded
  }
})();